import type { LinkFilterViewModel } from 'autogen/swagger/all';
import Menu from 'components/generic/menu';
import { BrandSpecificMenuItemStyling } from 'components/shared/productList/components/CategoryMenu/shared/styles';
import useGA4Tracking from 'modules/tracking/GA4/GA4Tracking';
import React from 'react';
import styled from 'styled-components';

const StyledSection = styled(Menu.Section)`
    padding: 0;

    & > div {
        padding-left: 0;
    }
`;

const StyledAnchorMenuItem = styled(Menu.Item.Anchor)<{ selected: boolean }>`
    ${BrandSpecificMenuItemStyling}

    & > a {
        padding-left: 0;
        padding-right: 0;
    }
`;

const StyledMenu = styled(Menu)`
    background-color: transparent;

    & > * {
        background-color: transparent;
    }
`;

export default function LinkFilter({ model: { displayName, options } }: { model: LinkFilterViewModel }) {
    const ga4Tracking = useGA4Tracking();

    return (
        <StyledMenu size="sm">
            <StyledSection headline={displayName}>
                {options.map((option) => (
                    <StyledAnchorMenuItem
                        key={option.displayName}
                        selected={option.isSelected}
                        anchorProps={{ action: option.linkAction }}
                        onClick={() =>
                            ga4Tracking({
                                eventName: 'link_click',
                                category: 'navigation',
                                eventParams: [
                                    { param_name: 'link_type', param_value: 'internal' },
                                    { param_name: 'list_name', param_value: displayName }
                                ]
                            })
                        }
                    >
                        {option.displayName}
                    </StyledAnchorMenuItem>
                ))}
            </StyledSection>
        </StyledMenu>
    );
}
